import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnChanges,
  SimpleChanges,
  forwardRef,
  ChangeDetectorRef
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { NzTreeComponent } from "ng-zorro-antd/tree";
import {
  FieldWrapper,
  KreFormFieldConfig,
  KreTableFieldConfig
} from "@kre-form/core";
import * as _ from "lodash";

import {
  ISelectedNode,
  IOrgData,
  ITreeData,
  ICheckedTree
} from "../../tools/util";
import { DataService } from "../../service/data.service";

@Component({
  selector: "kreform-org",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"],
  providers: [DataService]
})
export class KreFormOrg implements OnInit {
  @Input() fieldConfig: KreFormFieldConfig = {};
  @Input() tag: boolean = true;
  @Output() treeChangeEvent = new EventEmitter<any>();

  //组织数据
  data: ITreeData[] = [];
  dimension: boolean = true;
  selectData: ICheckedTree[] = [];
  curOrgId: string = "";

  //选择节点
  get selectedNode() {
    return _.cloneDeep(this.selectData);
  }

  get selectType() {
    let res = "";
    if (
      this.fieldConfig != undefined &&
      this.fieldConfig != null &&
      this.fieldConfig.templateOptions != undefined &&
      this.fieldConfig.templateOptions != null &&
      this.fieldConfig.templateOptions.selectType != undefined
    ) {
      res = this.fieldConfig.templateOptions.selectType;
    }
    return res;
  }

  orgData: IOrgData[] = [];
  treeData: ITreeData[] = [];

  controlid: string = "";
  treeid: string = "";


  @ViewChild("nzTreeComponent", { static: false })
  nzTreeComponent: NzTreeComponent | undefined;

  selectedKey: any[] = [];
  skeletonStatus: number = 0;


  constructor(public dataService: DataService, private cd: ChangeDetectorRef) { }

  ngOnInit() {
    let orgControl = _.get(this.fieldConfig, "templateOptions.controlid");
    if (orgControl != undefined && orgControl != null && orgControl != "") {
      this.controlid = _.get(this.fieldConfig, "templateOptions.controlid");
    }
    this.getOrgData();
  }


  ngAfterViewInit() {
    this.cd.detectChanges();
  }


  ngOnChanges(changes: SimpleChanges) { }

  //获取组织数据集
  getOrgData() {
    this.dataService.getSysCtrOrgTree().subscribe((res: any) => {
      this.data = res;
      if (this.data != null && this.data.length > 0) {
          if(this.data[0].children!=undefined){
          this.curOrgId = this.data[0].key;
          this.treeData = this.data[0].children;
        }
      }
      this.getTreeSelectData();
    });
  }

  getTreeSelectData() {
    if (
      this.fieldConfig != null &&
      this.fieldConfig.model != undefined &&
      this.fieldConfig.model != null &&
      this.fieldConfig.key != undefined &&
      this.fieldConfig.key != null &&
      this.fieldConfig.model[this.fieldConfig.key] != undefined &&
      this.fieldConfig.model[this.fieldConfig.key] != null
    ) {
      this.selectData = _.cloneDeep(
        this.fieldConfig.model[this.fieldConfig.key]
      );
    }
  }

  orgChange(event: any) {
    this.data.forEach((item: any) => {
      if (item.key === event) {
        this.treeData = item.children;
      }
    });
    this.selectData.forEach((item: any) => {
      this.setTreeChecked(this.data, item.value);
    });
  }

  treeChange(event: any) {
    if (this.dimension) {
      this.data.forEach((item: any) => {
        this.setTreeUnChecked(item.children, event.delete);
      });
    }
    this.treeChangeEvent.emit(this.selectData);
  }

  setTreeUnChecked(tree: ITreeData[], key: string) {
    if (tree && tree.length > 0) {
      tree.forEach((item: any) => {
        if (item.key === key) {
          item.checked = false;
        } else {
          if (item.children && item.children.length > 0) {
            this.setTreeUnChecked(item.children, key);
          }
        }
      });
    }
    return;
  }

  setTreeChecked(tree: ITreeData[], key: string) {
    if (tree && tree.length > 0) {
      tree.forEach((item: any) => {
        if (item.key === key) {
          item.checked = true;
        } else {
          if (item.children && item.children.length > 0) {
            this.setTreeChecked(item.children, key);
          }
        }
      });
    }
    return;
  }

}
